export const SET_LOCALE = 'SET_LOCALE';
export const SET_MESSAGES = 'SET_MESSAGES';
export const SET_PREV_PATH = 'SET_PREV_PATH';
export const SET_PREVIEW_DATE = 'SET_PREVIEW_DATE';
export const SET_PREV_LOCATION = 'SET_PREV_LOCATION';
export const SET_CLICKED_PID = 'SET_CLICKED_PID';
